import FasTimes from 'components/Legacy/Icons/FasTimes'
import React from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import { color, screenWidth } from 'utils'

const ModalBackground = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${color('blackAlpha75')};
  min-width: 10rem;
  max-width: 100%;
  z-index: 20; /* Hack to avoid header from steping out of modal BG, we should remove zindex from header */
`

const Overlay = styled.div<{ transparent: boolean }>`
  z-index: 19;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${(p) => (p.transparent ? 'trasnparent' : color('blackAlpha75'))};
`

const CloseIcon = styled(FasTimes)`
  position: absolute;
  right: 1rem;
  top: 1rem;
  cursor: pointer;
  height: 1.5rem;
  width: 1.5rem;
  fill: white;
  display: none;

  @media only screen and (max-width: ${screenWidth('sm')}) {
    display: block;
  }
`

type Props = {
  children: React.ReactNode
  className?: string
  onClickOut?: () => void
  onClose?: () => void
  overlay?: boolean
}
const Modal = ({ children, className, onClickOut, onClose, overlay }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null)
  const modalRoot = document.getElementById('modal') as Element
  const useOverlay = overlay ?? true

  return ReactDOM.createPortal(
    <>
      <ModalBackground className={className} ref={ref}>
        {onClose ? <CloseIcon data-e2e='closeButton' onClick={onClose} /> : null}
        {children}
      </ModalBackground>
      <Overlay
        transparent={!useOverlay}
        onMouseDown={() => {
          const handler = onClickOut ?? onClose
          if (handler) handler()
        }}
      />
    </>,
    modalRoot
  )
}

export default Modal
